(() => {
  /*
   * Le ancore devono reggere in tutte le lingue. L'id di un <h2> nasce dallo slug del
   * suo testo, quindi cambia con la traduzione: in tedesco «Größentabelle» non produrrà
   * mai «guida-alle-taglie», in cinese non produrrà niente. Per questo ogni ancora
   * canonica si può ritrovare anche per POSIZIONE: l'ordine degli <h2> è lo stesso in
   * tutte e sei le lingue, perché la traduzione traduce e non riordina.
   * Se la pagina cambia struttura, `totale` non torna più e la mappa si spegne da sola:
   * meglio nessuna ancora che un'ancora che porta nella sezione sbagliata.
   */
  const ANCORE_PER_PAGINA = {
    assistenza: {
      totale: 7,
      posizioni: {
        'guida-alle-taglie': 1,
        spedizioni: 2,
        'resi-e-cambi': 3,
        'come-funziona-il-preordine': 4,
        'com-e-fatto-il-tessuto': 5,
        'ordini-per-aziende-e-squadre': 7,
      },
    },
  };

  const ALIAS = {
    taglie: 'guida-alle-taglie',
    preordine: 'come-funziona-il-preordine',
    resi: 'resi-e-cambi',
    tessuto: 'com-e-fatto-il-tessuto',
    aziende: 'ordini-per-aziende-e-squadre',
  };

  const layouts = document.querySelectorAll('[data-oneshot-page-layout]');

  for (const layout of layouts) {
    const body = layout.querySelector('[data-oneshot-page-body]');
    const index = layout.querySelector('[data-oneshot-page-index]');
    const list = layout.querySelector('[data-oneshot-page-index-list]');
    const headings = body ? Array.from(body.querySelectorAll('h2')) : [];

    if (!body || !index || !list || headings.length < 3) continue;

    const usedIds = new Set(
      Array.from(document.querySelectorAll('[id]'))
        .map((element) => element.id)
        .filter(Boolean)
    );

    const makeSlug = (text, position) => {
      const base = text
        .toLowerCase()
        // Lettere che la scomposizione NFD non tocca e che altrimenti sparirebbero:
        // senza questa riga «Größentabelle» diventa «gro-entabelle».
        .replace(/ß/g, 'ss')
        .replace(/æ/g, 'ae')
        .replace(/œ/g, 'oe')
        .replace(/ø/g, 'o')
        .replace(/đ/g, 'd')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || `sezione-${position + 1}`;
      let slug = base;
      let suffix = 2;

      while (usedIds.has(slug)) {
        slug = `${base}-${suffix}`;
        suffix += 1;
      }

      usedIds.add(slug);
      return slug;
    };

    const links = new Map();

    headings.forEach((heading, position) => {
      if (!heading.id) heading.id = makeSlug(heading.textContent.trim(), position);

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
      links.set(heading.id, link);
    });

    index.hidden = false;

    const mappa = ANCORE_PER_PAGINA[layout.dataset.oneshotPageHandle || ''];
    const posizioni = mappa && mappa.totale === headings.length ? mappa.posizioni : {};

    const inserisciAncora = (id, heading) => {
      if (!heading || document.getElementById(id)) return;
      const ancora = document.createElement('span');
      ancora.id = id;
      ancora.className = 'oneshot-page__anchor-alias';
      ancora.setAttribute('aria-hidden', 'true');
      heading.parentNode.insertBefore(ancora, heading);
      usedIds.add(id);
    };

    const trovaSezione = (id) => {
      const perSlug = document.getElementById(id);
      if (perSlug) return perSlug;
      const posizione = posizioni[id];
      return posizione ? headings[posizione - 1] : null;
    };

    const applicaAlias = () => {
      // Prima le ancore canoniche italiane: sono quelle che usano i menu e i link esterni.
      // In italiano esistono già come slug e questo ciclo non fa niente.
      for (const id of Object.keys(posizioni)) inserisciAncora(id, headings[posizioni[id] - 1]);
      // Poi le scorciatoie brevi, agganciate alla stessa sezione.
      for (const [alias, target] of Object.entries(ALIAS)) inserisciAncora(alias, trovaSezione(target));
    };

    applicaAlias();

    const vaiAllAncora = () => {
      const hash = window.location.hash.slice(1);
      if (!hash) return;
      const bersaglio = document.getElementById(hash);
      if (bersaglio) bersaglio.scrollIntoView({ block: 'start' });
    };

    vaiAllAncora();
    window.addEventListener('hashchange', vaiAllAncora);

    if (!('IntersectionObserver' in window)) return;

    const visible = new Map();
    const activate = (id) => {
      for (const [headingId, link] of links) {
        if (headingId === id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
    };

    activate(headings[0].id);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.set(entry.target.id, entry.boundingClientRect.top);
          else visible.delete(entry.target.id);
        });

        const currentVisible = Array.from(visible.entries()).sort((a, b) => a[1] - b[1])[0];
        if (currentVisible) {
          activate(currentVisible[0]);
          return;
        }

        const passed = headings.filter((heading) => heading.getBoundingClientRect().top < 150);
        activate((passed[passed.length - 1] || headings[0]).id);
      },
      { rootMargin: '-120px 0px -62% 0px', threshold: [0, 1] }
    );

    headings.forEach((heading) => observer.observe(heading));
  }
})();
